import { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

export default function Dropdown({ img, alt, title, description, onDetails }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative w-full overflow-hidden">
      <div className="relative h-24">
        <img src={img} alt={alt || title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
        <button
          type="button"
          onClick={() => setOpen((prev) => !prev)}
          aria-expanded={open}
          className="absolute bottom-0 left-0 flex w-full items-center justify-between px-6 py-4 text-white"
        >
          <span className="text-start font-bold uppercase text-xl">{title}</span>
          {open ? <FaChevronUp size={20} /> : <FaChevronDown size={20} />}
        </button>
      </div>

      <div
        className={`grid bg-black transition-all duration-300 ease-in-out ${
          open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
        }`}
      >
        <div className="overflow-hidden">
          <div className="flex flex-col items-start gap-4 px-6 py-5 text-white">
            <p>{description}</p>
            <div className="flex gap-6">
              {onDetails && (
                <button onClick={onDetails} className="text-sm font-semibold uppercase underline">
                  Scopri di più
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
